<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
  }
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  background: #eff1f4;
}
.box {
  padding: 10px 20px 20px;
  min-height: 100%;
  box-sizing: border-box;
}
.content_box {
  padding-top: 20px;
}
.content_top {
  padding: 0 0 20px 0;
}
.icon_btn {
  height: 40px;
  line-height: 40px !important;
  padding: 0 15px 0 !important;
  overflow: hidden !important;
}
.icon_btn .icon {
  font-size: 24px;
  vertical-align: middle !important;
  margin-top: -5px !important;
}
.tips {
  color: #999;
  margin-left: 10px;
  font-size: 12px;
  letter-spacing: 1px;
}
.el-button {
  margin-right: 10px !important;
}
.el-button + .el-button {
  margin-left: 0 !important;
}
.el-dropdown-menu__item {
  padding: 0 !important;
}
.el-dropdown-menu__item span {
  padding: 0 20px;
}
.el-header {
  background-color: #304156;
  color: #fff;
  line-height: 60px;
  border-bottom: 1px solid #f5f5f5;
}
.el-header .el-col-3 {
  text-align: right;
  color: #fff;
}
.el-header .el-dropdown {
  color: #fff;
}
.el-breadcrumb {
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
}
.el-footer{
  background-color: #304156;
  text-align: center;
  color: #fff;
  line-height: 50px;
}
.el-aside{
  overflow: hidden !important;
}
.leftmenu > .el-aside{
   background-color: #304156;
  width: 204px !important;
}
.leftmenu .el-scrollbar {
  height: 100%;
  position: relative !important;
}
.leftmenu .el-scrollbar::after {
  content: "";
  width: 100%;
  height: 17px;
  position: absolute;
  bottom: -17px;
  left: 0;
  background-color: #304156;
}
.cell .el-button{
  padding: 0 8px;
  margin-right: 0 !important;
}
.cell .el-button.success{
  color: #67C23A;
}
.cell .el-button.warning{
  color: #E6A23C;
}
.cell .el-button.danger{
  color: #F56C6C;
}

#app .el-form-item{
  margin-bottom: 10px;
}
#app .el-menu-item i, #app .el-submenu__title i{
  color: #BFCBD9;
}
#app .el-menu-item.is-active i{
  color: #2086FF;
}
</style>
